/**
 * The latest of a value, for code that outlives a render (an editor's
 * extensions are made once, and read the value when they run).
 */
export class Latest<T> {
  private value: T
  constructor(value: T) {
    this.value = value
  }
  set(v: T) {
    this.value = v
  }
  get current(): T {
    return this.value
  }
}
